var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.5v-5c0-4.55 3.7-8.25 8.25-8.25s8.25 3.7 8.25 8.25v5c0 4.55-3.7 8.25-8.25 8.25s-8.25-3.7-8.25-8.25zm1.5-5v5c0 3.72 3.03 6.75 6.75 6.75s6.75-3.03 6.75-6.75v-5c0-3.72-3.03-6.75-6.75-6.75S5.25 5.78 5.25 9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.5v-2c0-1.24 1.01-2.25 2.25-2.25s2.25 1.01 2.25 2.25v2c0 1.24-1.01 2.25-2.25 2.25S9.75 10.74 9.75 9.5zm1.5-2v2c0 .41.34.75.75.75s.75-.34.75-.75v-2c0-.41-.34-.75-.75-.75s-.75.34-.75.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6V2c0-.41.34-.75.75-.75s.75.34.75.75v4c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMouse);
export default __webpack_public_path__ + "static/media/vuesax-outline-mouse.395ca8e0d2141136cd2384886da69444.svg";
export { ForwardRef as ReactComponent };